module.exports = __webpack_public_path__ + "static/media/533.11391479.png";